<template>
  <v-app>
    <AppHeader />

    <v-main>
      <router-view />
    </v-main>

    <AppFooter />
  </v-app>
</template>

<script lang="ts">
import { SwEnv } from "sw-gw-gui";
SwEnv.env = import.meta.env;

// import { swStore } from "sw-gw-gui";
import { defineComponent } from "vue";
// import PatientScript from "sw-gw-gui/js/patientscript";

export default defineComponent({
  name: "App",

  components: {},
  data() {
    return {
      // store: swStore(),
    };
  },
  mounted() {
    // var self = this;
    // console.log(new PatientScript());
    // loginutils.currentUser().then((user) => {
    //   if (user) {
    //     self.store._user = user;
    //     clinic.getCurrentClinic().then((clinic) => {
    //       clinic.loadUsers().then(() => {
    //         self.store._clinic = clinic;
    //       });
    //     });
    //   }
    // });
  },
});
</script>
